import { FC, ReactNode } from 'react'
import { LuInbox, LuRefreshCw, LuTriangleAlert } from 'react-icons/lu'

export const Skeleton: FC<{ className?: string }> = ({ className = '' }) => (
    <div aria-hidden className={`skeleton ${className}`} />
)

export const ChartSkeleton: FC = () => <Skeleton className='h-[240px] w-full rounded-xl sm:h-[300px]' />

export const Spinner: FC<{ className?: string, tone?: 'default' | 'inverse' }> = ({ className = '', tone = 'default' }) => (
    <span aria-hidden className={`inline-block h-4 w-4 animate-spin rounded-full border-2 motion-reduce:animate-none ${tone === 'inverse' ? 'border-white/40 border-t-white' : 'border-line border-t-primary'} ${className}`} />
)

interface IEmptyState {
    title?: string
    hint?: string
    action?: ReactNode
    compact?: boolean
}

export const EmptyState: FC<IEmptyState> = ({ title = '此期間沒有運動紀錄', hint, action, compact }) => (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8' : 'py-12'}`}>
        <span className='grid h-12 w-12 place-items-center rounded-full bg-canvas-deep text-ink-faint'>
            <LuInbox aria-hidden className='h-6 w-6' />
        </span>
        <p className='mt-3 text-h3 text-ink'>{title}</p>
        {hint && <p className='mt-1 text-sm text-ink-faint'>{hint}</p>}
        {action && <div className='mt-4'>{action}</div>}
    </div>
)

export const ErrorAlert: FC<{ message?: string, onRetry?: () => void }> = ({ message = '無法載入資料，請稍後再試', onRetry }) => (
    <div role='alert' className='flex flex-wrap items-center gap-3 rounded-xl bg-danger-50 px-4 py-3 text-sm text-danger'>
        <LuTriangleAlert aria-hidden className='h-5 w-5 shrink-0' />
        <p className='flex-1 font-medium'>{message}</p>
        {onRetry && <button type='button' onClick={onRetry} className='btn h-9 bg-surface px-3 text-danger shadow-control hover:shadow-control-hover'>
            <LuRefreshCw aria-hidden className='h-4 w-4' />重試
        </button>}
    </div>
)
